import { Box, Icon, Link, Text, VStack } from '@chakra-ui/react';
import { FaExclamationTriangle } from '@react-icons/all-files/fa/FaExclamationTriangle';

import { Button } from '../../../../components/ui/buttons/Button';
import getSearchPhoneNumbers from '../../../../utils/getSearchPhoneNumbers';

type MarketplaceErrorStateProps = {
  onRetry: () => void;
};

const MarketplaceErrorState = ({ onRetry }: MarketplaceErrorStateProps) => {
  const phone = getSearchPhoneNumbers();

  return (
    <Box
      bg="white"
      borderRadius="12px"
      p={{ base: '24px', md: '32px' }}
      border="1px solid"
      borderColor="grayMediumBackground"
      maxW="520px"
      mx="auto"
    >
      <VStack spacing={4} textAlign="center">
        <Icon as={FaExclamationTriangle} boxSize="40px" color="leaseEndRed" />
        <Text fontWeight="600" fontSize="lg" color="grayDark">
          We're having trouble loading your dashboard
        </Text>
        <Text fontSize="sm" color="grayLight">
          This usually fixes itself in a few minutes.
        </Text>
        <Button
          onClick={onRetry}
          trackClick="marketplace_dashboard_retry"
          bg="oceanBoatBlue"
          color="white"
          w="100%"
          size="lg"
          _hover={{ bg: 'royalBlueDark' }}
        >
          Try again
        </Button>
        <Text fontSize="sm" color="gray.500">
          Still not working?{' '}
          <Link href={`tel:+1${phone.replace(/\D/g, '')}`} fontWeight="600" color="oceanBoatBlue">
            Call us at {phone}
          </Link>
        </Text>
      </VStack>
    </Box>
  );
};

export default MarketplaceErrorState;
